var ImageLoadings;
(function (ImageLoadings) {
    ImageLoadings["Lazy"] = "lazy";
    ImageLoadings["Eager"] = "eager";
})(ImageLoadings || (ImageLoadings = {}));

export { ImageLoadings };
